import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { dsDtos } from '@vectronic/openApi-admin';
import { CardComponent } from '@vectronic/ui';
import { GpsXFileImportService } from '../../services/gps-x-file-import.service';
import { EditScheduleTemplateComponent } from '../edit-schedule-template/edit-schedule-template.component';

@Component({
  selector: 'rc-schedule-template-modal',
  templateUrl: './schedule-template-modal.component.html',
  styleUrls: ['./schedule-template-modal.component.scss'],
  imports: [
    CardComponent,
    MatDialogModule,
    MatProgressSpinnerModule,
    EditScheduleTemplateComponent,
  ],
})
export class ScheduleTemplateModalComponent {
  dialogRef = inject(MatDialogRef<ScheduleTemplateModalComponent>);
  gpsXFileImportService = inject(GpsXFileImportService);
  data: {
    scheduleTemplate?: dsDtos.ScheduleTemplateAdmin;
    hideCustomerVisibility?: boolean;
    hideUserId?: boolean;
  } = inject(MAT_DIALOG_DATA);
  result: dsDtos.AddScheduleTemplateAdmin;

  onSave(result: dsDtos.AddScheduleTemplateAdmin): void {
    this.dialogRef.close(result);
  }
}
